import { Variants } from 'framer-motion';

// Variantes de animação para elementos do formulário
export const formItemVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i: number) => ({ 
    opacity: 1, 
    y: 0,
    transition: { 
      type: "spring", 
      stiffness: 200, 
      damping: 20,
      delay: i * 0.1 
    }
  }),
  exit: { 
    opacity: 0, 
    y: -20, 
    transition: { 
      duration: 0.3 
    } 
  }
};

// Variantes para botões
export const buttonVariants: Variants = {
  hover: { scale: 1.03, transition: { duration: 0.2 } },
  tap: { scale: 0.97 }
};

// Variantes para o container
export const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1,
    transition: { 
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  }
};
